import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DialogContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton, Alert } from '@material-ui/lab';
import { BatchInProgressIndicator } from '~/modules/common/components';
import { getTextInBold } from '~/modules/common/util';

const useBatchInProgressIndicatorStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    padding: theme.spacing(4.25, 0)
  }
}));

const useStyles = makeStyles(theme => ({
  alert: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  content: {
    minWidth: theme.spacing(71.25),
    minHeight: theme.spacing(13.5)
  },
  confirmationMessage: {
    padding: theme.spacing(2, 0, 0, 0)
  },
  skeleton: {
    margin: theme.spacing(2, 0, 0, 0)
  }
}));

const DialogContentLoading = ({ classes }) => {
  return (
    <>
      <Skeleton height={30} width="100%" variant="rect" />
      <Skeleton
        className={classes.skeleton}
        height={20}
        width="100%"
        variant="rect"
      />
    </>
  );
};

const BulkUnassignTasksDialogContent = ({
  assignedTasksCount,
  dialogDescribedById,
  hasTaskResourceAllocation,
  isBulkUnassignTasksInProgress,
  isLoading,
  resourceUserName
}) => {
  const classes = useStyles();
  const batchIndicatorClasses = useBatchInProgressIndicatorStyles();

  const warningMessageId = hasTaskResourceAllocation
    ? 'taskAssignmentBulkActionDialog.removeAllTaskAssignmentsWithAllocationWarningMessage'
    : 'taskAssignmentBulkActionDialog.removeAllTaskAssignmentsWarningMessage';
  const confirmationMessageId = hasTaskResourceAllocation
    ? 'taskAssignmentBulkActionDialog.removeAllTasksAssignmentsWithAllocationConfirmationMessage'
    : 'taskAssignmentBulkActionDialog.removeAllTasksAssignmentsConfirmationMessage';

  return (
    <DialogContent id={dialogDescribedById} className={classes.content}>
      {isBulkUnassignTasksInProgress ? (
        <BatchInProgressIndicator
          messageId="taskAssignmentBulkActionDialog.removingAllTasksAssignments"
          classes={batchIndicatorClasses}
        />
      ) : (
        <>
          {isLoading ? (
            <DialogContentLoading classes={classes} />
          ) : (
            <>
              <Alert severity="warning" icon={false} className={classes.alert}>
                <Typography>
                  <FormattedMessage
                    id={warningMessageId}
                    values={getTextInBold({
                      resourceUserName,
                      assignedTasksCount
                    })}
                  />
                </Typography>
              </Alert>
              <Typography className={classes.confirmationMessage}>
                <FormattedMessage id={confirmationMessageId} />
              </Typography>
            </>
          )}
        </>
      )}
    </DialogContent>
  );
};

BulkUnassignTasksDialogContent.propTypes = {
  assignedTasksCount: PropTypes.number,
  dialogDescribedById: PropTypes.string.isRequired,
  isBulkUnassignTasksInProgress: PropTypes.bool,
  hasTaskResourceAllocation: PropTypes.bool,
  isLoading: PropTypes.bool,
  resourceUserName: PropTypes.string
};

DialogContentLoading.propTypes = {
  classes: PropTypes.object
};
export default BulkUnassignTasksDialogContent;
